import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import CustomModal from "../../../components/customModal/CustomModal";
import useInventory from "../../../Hooks/useInventory";
import Loading from "../../../components/LoadingPage/Loading";

interface UnitOption {
  id: string;
  unitName: string;
}

interface SelectOption {
  value: string;
  label: string;
}

interface AddOrderingProductModalProps {
  mcKessonUOMId: string;
  onClose: () => void;
  onSuccess: () => void;
}

const AddOrderingProductModal: React.FC<AddOrderingProductModalProps> = ({
  mcKessonUOMId,
  onClose,
  onSuccess,
}) => {
  const {
    getItemDropdownVal,
    createItemDropdownvalLoading,
    upsertOrderingProductAPI,
    upsertOrderingProductLoading,
  } = useInventory();
  const [unitOptions, setUnitOptions] = useState<SelectOption[]>([]);
  const [selectedUnit, setSelectedUnit] = useState<SelectOption | null>(null);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    const fetchUnits = async () => {
      try {
        const result = await getItemDropdownVal();
        if (result?.units) {
          setUnitOptions(
            result.units.map((unit: UnitOption) => ({
              value: unit.id,
              label: unit.unitName,
            }))
          );
        }
      } catch (err: any) {
        toast.error(err.message || "Failed to load units");
      }
    };
    fetchUnits();
  }, []);

  const handleSubmit = async () => {
    if (!selectedUnit) {
      setError("Please select a unit");
      return;
    }
    try {
      await upsertOrderingProductAPI({
        mcKessonUOMId,
        unitId: selectedUnit.value,
      });
      onSuccess();
    } catch (err: any) {
      toast.error(err.message || "Failed to add ordering product");
    }
  };

  return (
    <>
      {(createItemDropdownvalLoading || upsertOrderingProductLoading) && <Loading />}
      <CustomModal
        title="Add Into Ordering Product"
        content={
          <div className="modal--content--wrapper">
            <div className="modal--inputbox">
              <Form.Group className="mb-3">
                <Form.Label>Select Unit</Form.Label>
                <Select
                  options={unitOptions}
                  value={selectedUnit}
                  onChange={(option) => {
                    setSelectedUnit(option);
                    if (option) setError("");
                  }}
                  placeholder="Select"
                  isClearable
                  classNamePrefix="react-select"
                  className={`${error ? "is-invalid-border" : ""} react-select-container`}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
                {error && (
                  <Form.Control.Feedback type="invalid">
                    {error}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="full-width text-end">
                <Button
                  onClick={onClose}
                  style={{ marginRight: "10px" }}
                  variant="outline-primary"
                >
                  Cancel
                </Button>
                <Button onClick={handleSubmit} variant="primary">
                  Add
                </Button>
              </Form.Group>
            </div>
          </div>
        }
        onClose={onClose}
      />
    </>
  );
};

export default AddOrderingProductModal;
